import { render } from "./viewpyramide.vue?vue&type=template&id=cc33b4ec"
import script from "./viewpyramide.vue?vue&type=script&lang=js"
export * from "./viewpyramide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__